// Feature flags
export enum FeatureFlags {
  SHOW_DEMO_STUDIO = 'show-secret-page',
  SHOW_PERFORMANCE = 'show-performance-page',
}
